import {
  fetchInitialFormData,
  FetchInitialFormDataPayload,
} from '../../fetcher';
import {
  updatePage,
  useUpdatePageDispatch,
  useSetCurrentPageStateDispatch,
  setCurrentPageState,
  CURRENT_PAGE_STATE_TYPE,
} from '../../store';
import { convertPageTypeIntoCurrentPageStateType } from '../shared';
import { handleError, NEXT_ERROR_PAGE_TYPE } from './handleError';
import { commonError } from './shared';

export type InitializePayload = Partial<FetchInitialFormDataPayload>;
export type UseInitializeReturnType = {
  initialize: (payload: InitializePayload) => Promise<void>;
};

export const useInitialize = (): UseInitializeReturnType => {
  const dispatchUpdatePage = useUpdatePageDispatch();
  const dispatchSetCurrentPageState = useSetCurrentPageStateDispatch();
  const initialize: UseInitializeReturnType['initialize'] = async ({
    endpoint,
  }) => {
    if (endpoint == null) {
      dispatchSetCurrentPageState(
        setCurrentPageState({
          type: CURRENT_PAGE_STATE_TYPE.error,
          error: commonError,
        }),
      );
      return;
    }
    try {
      const {
        page,
        inputData,
        reCaptcha,
        trackingSetting,
        externalMeasurementTag,
        apiEndpoint,
        authentication,
        fileUpload: fileUploadSetting,
        accessReportSetting,
      } = await fetchInitialFormData({
        endpoint,
      });
      dispatchUpdatePage(
        updatePage({
          nextFormPage: page,
          inputData,
          nextPageState: {
            type: convertPageTypeIntoCurrentPageStateType(page.pageType),
          },
          reCaptchaSetting: reCaptcha,
          trackingSetting,
          externalMeasurementTag,
          apiEndpoint,
          authentication,
          fileUploadSetting,
          accessReportSetting,
        }),
      );
    } catch (e: unknown) {
      const result = handleError(e);
      if (result.type === NEXT_ERROR_PAGE_TYPE.receptionAuthenticationError) {
        const {
          page,
          inputData,
          reCaptcha,
          trackingSetting,
          error,
          externalMeasurementTag,
          apiEndpoint,
          fileUpload: fileUploadSetting,
          accessReportSetting,
        } = result.data;
        dispatchUpdatePage(
          updatePage({
            nextFormPage: page,
            inputData,
            nextPageState: {
              type: convertPageTypeIntoCurrentPageStateType(page.pageType),
            },
            reCaptchaSetting: reCaptcha,
            trackingSetting,
            globalErrors: error?.global,
            externalMeasurementTag,
            apiEndpoint,
            fileUploadSetting,
            accessReportSetting,
          }),
        );
        return;
      }

      const type =
        result.type === NEXT_ERROR_PAGE_TYPE.error
          ? CURRENT_PAGE_STATE_TYPE.error
          : CURRENT_PAGE_STATE_TYPE.maintenance;
      dispatchSetCurrentPageState(
        setCurrentPageState({
          type,
          error: result.error,
        }),
      );
    }
  };
  return { initialize };
};
